<template>
    <f7-page
        name="Settings"
        class="onboardingBg"
    >
        <f7-navbar
            large
            no-hairline
            large-transparent
            inner-class="onboardingBg"
            title-large="Settings"
        >
            <f7-nav-left>
                <f7-link
                    icon="ion-ios-arrow-left"
                    @click="save(true)"
                />
            </f7-nav-left>
            <f7-nav-title>Settings</f7-nav-title>
            <f7-nav-right>
                <span class="wide">
                    <f7-link @click="save()">Save</f7-link>
                </span>

            </f7-nav-right>
        </f7-navbar>
        <f7-block
            v-if="user.email && !user.emailVerified"
            style="background: #FC6E65; color: white; padding: 10px; margin: 10px 0 0 0"
        >Oops! It looks like you forgot to verify your email. Didn't receive anything? Click
            <a
                href="#"
                style="text-decoration: underline; color: white;"
                @click="resendEmail"
            >HERE</a>
            to resend.</f7-block>
        <f7-block-title>Public Account Settings</f7-block-title>
        <f7-list
            inset
            class="bordered"
        >
            <f7-list-input
                :value="user.username"
                label="Username"
                type="text"
                placeholder="Your name"
                @input="user.username=$event.target.value.replace(/[\W_]+/g, '_')"
            />
        </f7-list>
        <f7-block-title>Private Account Settings</f7-block-title>
        <f7-list
            inset
            class="bordered"
        >
            <f7-list-input
                :value="user.name"
                label="Full name"
                type="text"
                placeholder="Your name"
                @input="user.name=$event.target.value"
            />
            <li @click="updateEmail">
                <f7-list-input
                    :wrap="false"
                    :value="user.email"
                    label="E-mail"
                    type="email"
                    placeholder="Your e-mail"
                    link="#"
                    disabled
                />
            </li>
            <li v-if="user.phone">
                <f7-list-input
                    :wrap="false"
                    :value="user.phone"
                    label="Phone number"
                    type="text"
                    placeholder="Your phone number"
                    link="#"
                    disabled
                />
            </li>
            <f7-list-item
                v-if="!user.phone"
                link="#"
                style="text-transform: capitalize"
                @click="updatePassword"
            >Change password</f7-list-item>
            <f7-list-item
                link="/traits"
                style="text-transform: capitalize"
            >Traits</f7-list-item>
            <f7-list-item
                link="/settings/goals"
                style="text-transform: capitalize"
            >Goals</f7-list-item>
            <f7-list-item
                :after="user.hasPartner ? 'Connected' : 'Not Set up'"
                link="/partners"
                title="Partner"
                style="text-transform: capitalize"
            />
            <f7-list-item
                :after="user.isSubscribed ? 'Active' : 'Not active'"
                title="Subscription"
                link="/subscription"
            />
            <f7-list-item>
                <div class="item-title">Dark Mode</div>
                <div class="item-after">
                    <label class="toggle">
                        <f7-toggle
                            :checked="!!darkTheme"
                            @toggle:change="toggleDarkTheme()"
                        />
                    </label>
                </div>
            </f7-list-item>
        </f7-list>

        <f7-block-title>Communications</f7-block-title>
        <f7-block style="margin-top: -16px">
            <f7-segmented
                raised
                tag="p"
            >
                <f7-button
                    :tab-link-active="commsTab === 'email'"
                    @click="setCommsTab('email');"
                >EMAIL</f7-button>
                <f7-button
                    :tab-link-active="commsTab === 'push'"
                    @click="setCommsTab('push');"
                >PUSH</f7-button>
                <f7-button
                    v-if="user.phone"
                    :tab-link-active="commsTab === 'sms'"
                    @click="setCommsTab('sms');"
                >SMS</f7-button>
            </f7-segmented>
        </f7-block>

        <f7-tabs>

            <f7-tab
                v-if="commsTab === 'push'"
                id="coms-tab-1"
                tab-active
            >
                <f7-list
                    inset
                    class="bordered"
                    style="margin-top: -16px"
                >
                    <f7-list-item>
                        <div class="item-title">Pulse reminder</div>
                        <div class="item-after">
                            <label class="toggle">
                                <f7-toggle
                                    :checked="user.communication.push.pulse"
                                    @toggle:change="toggleComs('push', 'pulse')"
                                />
                            </label>
                        </div>
                    </f7-list-item>
                    <f7-list-item>
                        <div class="item-title">Partner & community activity</div>
                        <div class="item-after">
                            <label class="toggle">
                                <f7-toggle
                                    :checked="user.communication.push.activity"
                                    @toggle:change="toggleComs('push', 'activity')"
                                />
                            </label>
                        </div>
                    </f7-list-item>
                    <f7-list-item>
                        <div class="item-title">Content & news updates</div>
                        <div class="item-after">
                            <label class="toggle">
                                <f7-toggle
                                    :checked="user.communication.push.news"
                                    @toggle:change="toggleComs('push', 'news')"
                                />
                            </label>
                        </div>
                    </f7-list-item>
                </f7-list>
            </f7-tab>
            <f7-tab
                v-else-if="commsTab === 'email'"
                id="coms-tab-2"
                tab-active
            >
                <f7-list
                    inset
                    class="bordered"
                    style="margin-top: -16px"
                >
                    <f7-list-item>
                        <div class="item-title">Pulse reminder</div>
                        <div class="item-after">
                            <label class="toggle">
                                <f7-toggle
                                    :checked="user.communication.email.pulse"
                                    @toggle:change="toggleComs('email', 'pulse')"
                                />
                            </label>
                        </div>
                    </f7-list-item>
                    <f7-list-item>
                        <div class="item-title">Partner & community activity</div>
                        <div class="item-after">
                            <label class="toggle">
                                <f7-toggle
                                    :checked="user.communication.email.activity"
                                    @toggle:change="toggleComs('email', 'activity')"
                                />
                            </label>
                        </div>
                    </f7-list-item>
                    <f7-list-item>
                        <div class="item-title">Content & news updates</div>
                        <div class="item-after">
                            <label class="toggle">
                                <f7-toggle
                                    :checked="user.communication.email.news"
                                    @toggle:change="toggleComs('email', 'news')"
                                />
                            </label>
                        </div>
                    </f7-list-item>
                </f7-list>
            </f7-tab>
            <f7-tab
                v-else-if="commsTab === 'sms'"
                id="coms-tab-3"
                tab-active
            >
                <span :key="smsKey">
                    <f7-list
                        inset
                        class="bordered"
                        style="margin-top: -16px"
                    >
                        <f7-list-item>
                            <div class="item-title">Pulse reminder</div>
                            <div class="item-after">
                                <label class="toggle">
                                    <f7-toggle
                                        :checked="user.complianceSMS && user.complianceSMS.optOut ? false : user.communication.sms.pulse"
                                        @toggle:change="toggleComs('sms', 'pulse')"
                                    />
                                </label>
                            </div>
                        </f7-list-item>
                        <f7-list-item>
                            <div class="item-title">Partner & community activity</div>
                            <div class="item-after">
                                <label class="toggle">
                                    <f7-toggle
                                        :checked="user.complianceSMS && user.complianceSMS.optOut ? false : user.communication.sms.activity"
                                        @toggle:change="toggleComs('sms', 'activity')"
                                    />
                                </label>
                            </div>
                        </f7-list-item>
                        <f7-list-item>
                            <div class="item-title">Content & news updates</div>
                            <div class="item-after">
                                <label class="toggle">
                                    <f7-toggle
                                        :checked="user.complianceSMS && user.complianceSMS.optOut ? false : user.communication.sms.news"
                                        @toggle:change="toggleComs('sms', 'news')"
                                    />
                                </label>
                            </div>
                        </f7-list-item>
                    </f7-list>
                </span>
            </f7-tab>
            <f7-block v-if="commsTab === 'push' && isPgap">
                To receive push notifications, remember to allow notifications in your phone settings. <a @click="enablePush">Click here</a> to go there now.
            </f7-block>

            <f7-block-title>Privacy & legal</f7-block-title>
            <f7-list
                inset
                class="bordered"
            >
                <f7-list-item
                    link="/termsOfUse"
                    style="text-transform: capitalize"
                >Terms & conditions</f7-list-item>
                <f7-list-item
                    link="/privacy"
                    style="text-transform: capitalize"
                >Privacy</f7-list-item>
                <f7-list-item
                    link="/data"
                    style="text-transform: capitalize"
                >My data</f7-list-item>
            </f7-list>

            <f7-block-title>Other</f7-block-title>
            <f7-list
                inset
                form
                class="bordered"
            >
                <f7-list-item
                    v-if="user.isAdmin"
                    link="/admin"
                    style="text-transform: capitalize"
                >Admin stuff</f7-list-item>
                <f7-list-item
                    link="/help"
                    style="text-transform: capitalize; white-space: nowrap"
                >Help</f7-list-item>
                <f7-list-item
                    link="/about"
                    style="text-transform: capitalize"
                >About</f7-list-item>
                <f7-list-item
                    link="#"
                    @click="openFeedback"
                >Feedback</f7-list-item>
                <f7-list-item
                    link="#"
                    @click="logout"
                >Log out</f7-list-item>
            </f7-list>
            <div
                class="list-block-label"
                style="margin: 10px 0 0;text-align: center; color: gray;
    font-size: 11px;"
            >

                <svg
                    width="120px"
                    viewBox="0 0 432 142"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <path
                        fill="#ccc"
                        d="M125.07,55.31c-1.45,3.77-2.36,6.07-3.19,6-.33,0-1-.69-1.11-1.53-6-19.45-22.11-25.6-39-26.14-30.19-1-48,20.25-48.89,49.77-.91,28.87,14.24,53.76,45.43,54.74,22.06.7,36.48-9,42.66-20.41.77-1,1.93-3.12,2.83-4.69a1.19,1.19,0,0,1,2.12.12c1.5,3.45,4.5,9.33,5.65,11.57a1.2,1.2,0,0,1-.35,1.51l-4.48,3.3c-13.91,9.36-31,13.3-47.73,12.77-32.18-1-65.09-21.14-64-57C16.2,48.06,47.7,28.46,82,29.54c17.76.56,33.28,5.86,45.8,15.7a1.23,1.23,0,0,1,.38,1.37Z"
                    />
                    <path
                        fill="#ccc"
                        d="M180.77,51.13c25.07,0,49.13,18.25,49.13,45.64s-24.06,45.64-49.13,45.64-49.12-18.26-49.12-45.64S155.71,51.13,180.77,51.13Zm0,87.13c24.57,0,33.37-18.92,33.2-41.49.17-22.57-8.63-41.5-33.2-41.5s-33.36,18.93-33.19,41.5C147.41,119.34,156.21,138.26,180.77,138.26Z"
                    />
                    <path
                        fill="#ccc"
                        d="M279.74,67.72c-2-1.66-4.48-4.31-9-4.31-13.94,0-18.42,16.76-18.42,43v10.13c0,12.28,1.49,20.08,8.13,20.91,1.82.17,2.82.83,2.82,2,0,.83-.5.83-1.33.83-2.82,0-9-.33-14.77-.33s-12,.33-14.77.33c-.83,0-2-.33-2-.83,0-.66,1.16-1.49,2.82-2.15,5.31-2.66,6.8-8.47,6.8-23.74V65.4c0-3.32-2.82-5.48-5.64-6.47-1.33-.34-2.49-1-2.49-1.33s1-.67,2.16-1L251.36,52V75.19h.33c7.47-16.26,17.26-24.06,33.69-24.06Z"
                    />
                    <path
                        fill="#ccc"
                        d="M370.69,115c0,10.46,1.33,21.25,5.81,22.74.83.34,1.33.83,1.33,1.33a1.35,1.35,0,0,1-1.5,1.16c-.66,0-4.65-.33-6.47-.33-2.16,0-4.32.33-6.14.33-1.33,0-2-.83-2-1.32,0-4.15-2.33-11-2.82-15.61h-.34c-7.13,14.28-19.75,19.09-35,19.09-16.1,0-35.35-8.46-35.35-26.56,0-25.39,37.84-29.21,56.6-29.21h12.61c0-19.42-5.48-31.37-26.56-31.37-11.61,0-30.37,6.31-31.86,19.42,0,.5-.33.67-.83.67-.33,0-.5,0-.67-.5L293,59.09a96.52,96.52,0,0,1,37.35-8c30.2,0,40.33,13.11,40.33,32.36ZM345.13,90.79c-17.59,0-41,3.32-41,25.4,0,14.6,11.29,22.07,24.73,22.07,24.9,0,28.55-19.92,28.55-40.16V90.79Z"
                    />
                    <path
                        fill="#ccc"
                        d="M407.38,115.85c0,9.63.83,19.42,6.14,21.58,1.66.67,3.49,1.33,3.49,2.16,0,.5-2,.66-2.82.66-2,0-8.14-.33-12.95-.33s-10.95.33-13.77.33c-3,0-3.66-.16-3.66-.66,0-.83,2.16-1.49,4.49-2.49,6-2.66,6.8-17.1,6.8-34.36V43.82c0-12.45-1.33-16.1-5.81-17.76-1.16-.33-1.66-.66-1.66-1,0-.5.83-.83,1.5-1l18.25-4.48Z"
                    />

                </svg><br>
                <span class="version">
                    version {{ version }}</span><br>
                <span class="version">
                    b.{{ buildNumber }}</span><br><br></div>

        </f7-tabs>
    </f7-page>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
    store: ['api', 'text', 'user', 'darkTheme'],
    data () {
        return {
            commsTab: 'email',
            nativePerm: '',
            loaded: false,
            checked: false,
            smsKey: 0,
            pushEnabled: false,
        };
    },
    computed: {
        version: function () {
            return window.version || '1.0.0';
        },
        isPgap: function () {
            return pgap;
        },
        buildNumber: function () {
            return window.localStore.getItem('chcpBuildNumber') || 'xx.xx.xx';
        },
    },
    watch: {
        user: function () {
            this.loaded = false;
            setTimeout(() => {
                // for toggle else infinite loop
                this.loaded = true;
            }, 500);
        }
    },
    created: function () {
    },
    mounted: function () {
        setTimeout(() => {
            // for toggle else infinite loop
            this.loaded = true;
        }, 500);
    },
    methods: {
        checkNativePerms: function () {
            if (!pgap) return;
            if (typeof PushNotification === 'undefined') return;
            window.PushNotification.hasPermission(data => {
                this.pushEnabled = data.isEnabled ? 'granted' : 'not granted';
            });
        },
        enablePush: function () {
            const { OpenAppSettings } = window.cordova.plugins;
            OpenAppSettings.open();
        },
        setCommsTab: function (type) {
            this.loaded = false;
            this.commsTab = type;
            if (type === 'push') this.checkNativePerms();
            setTimeout(() => {
                // for toggle else infinite loop
                this.loaded = true;
            }, 500);
        },
        toggleDarkTheme: function () {
            if (!this.loaded) return;
            this.darkTheme = !this.darkTheme;
            if (this.darkTheme) localStore.setItem('darkTheme', 1);
            else localStore.removeItem('darkTheme');
            if (this.darkTheme) {
                this.$f7.statusbar.setTextColor('white');
            } else {
                this.$f7.statusbar.setTextColor('black');
            }
        },
        resendEmail: function () {
            var user = firebase.auth().currentUser;
            user.sendEmailVerification()
                .then(function () {
                    f7.dialog.alert('Email sent.');
                })
                .catch(function (error) {
                    console.log('email v ', error);
                });
        },
        updateEmail: function () {
            var user = firebase.auth().currentUser;
            if (!this.user.email && this.user.phone) {
                if (pgap) {
                    return f7.dialog.alert('Adding your email to you account can only happen on the web at this time. Please visit https://getcoral.app and login there.')
                }
                f7.dialog.prompt('Enter your email?', newEmail => {
                    user.updateEmail(newEmail).then(() => {
                        f7.dialog.prompt('When you add your email, you must also set a password so you can login with it. Min 6-characters.', newPassword => {
                            user.updatePassword(newPassword).then(() => {
                                f7.dialog.alert('All set correctly!');
                            }).catch((error) => {
                                f7.dialog.alert('Error :' + error.message);
                            });
                        });
                    }).catch((error) => {
                        //Logout if session expires !
                        if (error.code == 'auth/requires-recent-login') {
                            f7.dialog.alert('Your Session has been Expired, you need a fresh session to set a password! Please try again !');
                            this.logout();
                        } else {
                            f7.dialog.alert('Error :' + error.message)
                        }
                    });
                });
                return;
            }
            f7.dialog.password('To change your email, first enter your password again.', password => {
                const credential = firebase.auth.EmailAuthProvider.credential(user.email, password);
                user.reauthenticateAndRetrieveDataWithCredential(credential)
                    .then(() => {
                        // User re-authenticated.
                        f7.dialog.prompt('Enter new email', newEmail => {
                            function validateEmail (email) {
                                // eslint-disable-next-line no-useless-escape
                                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                return re.test(String(email).toLowerCase());
                            }
                            if (!validateEmail(newEmail)) return f7.dialog.alert('Invalid email.');
                            this.$http
                                .post(`${this.api}/services/checkEmail`, {
                                    email: newEmail
                                })
                                .then(
                                    data => {
                                        if (data.body.isUsed)
                                            return f7.dialog.alert('This email is already in use on another account.');
                                        user.updateEmail(newEmail)
                                            .then(() => {
                                                this.user.email = newEmail;
                                                this.save();
                                                // Update successful.
                                                var user = firebase.auth().currentUser;
                                                user.sendEmailVerification()
                                                    .then(() => {
                                                        // Email sent.
                                                    })
                                                    .catch(() => {
                                                        // An error happened.
                                                    });
                                            })
                                            .catch(() => {
                                                // An error happened.
                                                f7.dialog.alert('Could not update your email.');
                                            });
                                    },
                                    () => {
                                        f7.dialog.alert('Could not check if this email can be used.');
                                    }
                                );
                        });
                    })
                    .catch(() => {
                        // An error happened.
                        f7.dialog.alert('Could not authenticate you.');
                    });
            });
        },
        updatePassword: function () {
            var user = firebase.auth().currentUser;
            f7.dialog.password('Enter your current password to proceed with changing your password.', password => {
                const credential = firebase.auth.EmailAuthProvider.credential(user.email, password);
                user.reauthenticateAndRetrieveDataWithCredential(credential)
                    .then(() => {
                        f7.dialog.password('Enter a new password', newPassword => {
                            user.updatePassword(newPassword)
                                .then(() => {
                                    f7.dialog.alert('Password update successful!');
                                })
                                .catch(() => {
                                    f7.dialog.alert('Could NOT update your password. Too short or invalid password.');
                                });
                        });
                    })
                    .catch(() => {
                        // An error happened.
                        f7.dialog.alert('Could not authenticate you.');
                    });
            });
        },
        toggleComs: function (type, selection) {
            if (!this.loaded) return;
            this.loaded = false;
            const { communication } = this.user;
            let optOut = false;
            if (this.user.complianceSMS) optOut = this.user.complianceSMS.optOut;
            if (type === 'sms') {
                if (optOut) {
                    f7.dialog.alert(
                        'To turn your SMS notification back on, please find any text we previously sent you and reply to it with "START"',
                        'Send us a text to confirm!',
                        () => this.smsKey++ //rerender
                    )

                    return null;
                } else {
                    communication[type][selection] = !communication[type][selection];
                    this.$events.fire('notifications-sms');
                    return null;
                }
            }

            communication[type][selection] = !communication[type][selection];
            setTimeout(() => {
                this.loaded = true;
            }, 200);
        },
        save: function (andGo, cb) {
            f7.preloader.show();
            this.$http.put(`${this.api}/users/${this.user.id}`, this.user).then(
                response => {
                    this.$events.fire('trackEvent', 'settings_saved');
                    this.user = response.body;
                    f7.preloader.hide();
                    if (typeof cb !== 'undefined') cb();
                    if (andGo) {
                        if (f7.views['main'].router.history.length === 1) {
                            return f7.views['main'].router.navigate('/home', { clearPreviousHistory: true });
                        }
                        return f7.views['main'].router.back();
                    }
                },
                response => {
                    f7.preloader.hide();
                    this.$events.fire('trackEvent', 'settings_saved_error', 'error');
                    f7.dialog.alert(response.body.message || 'Something went wrong');
                }
            );
        },
        openFeedback: function () {
            if (pgap) {
                cordova.plugins.email.open({
                    to: ['support@getcoral.app'],
                    subject: 'Coral Feedback',
                    body:
                        'Please mention what browser or phone you are using if you are reporting any bugs. Thank you!',
                    isHtml: true
                });
            } else {
                window.open(
                    'mailto:support@getcoral.app?subject=' +
                    'Coral Feedback' +
                    '&body=' +
                    'Please mention what browser or phone you are using if you are reporting any bugs. Thank you!'
                );
            }
        },
        logout: function () {
            this.save(false, () => {
                f7.dialog.confirm('Are you sure you want to logout?', () => {
                    this.$events.fire('userLogout');
                    const onDone = () => {
                        setTimeout(() => {
                            // give time for events to fire (eg: trackers)
                            localStore.removeItem('uuid');
                            localStore.removeItem('jwt');
                            localStore.removeItem('notifications-push');
                            localStore.removeItem('adminUnlockAll');
                            localStore.removeItem('notifications');
                            localStore.removeItem('promptedToGetApp');
                            if (pgap) {
                                window.location.reload();
                            } else {
                                window.location.href = '/';
                            }
                        }, 400);
                    };
                    if (pgap && cordova.plugins.firebase && cordova.plugins.firebase.auth) {
                        cordova.plugins.firebase.auth.signOut();
                    }
                    firebase
                        .auth()
                        .signOut()
                        .then(onDone)
                        .catch(onDone);
                });
            });
        }
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
.center {
    text-align: center;
}
.version {
    text-transform: uppercase;
    font-family: AndesMedium;
    letter-spacing: 1px;
    color: #ccc;
    line-height: 20px;
    text-transform: uppercase;
}
</style>
